import $ from 'jquery';
import Swiper from 'swiper';

const rankingTabs = $('.js-ranking-tabs');
const rankingTabsContent = $('.ranking--tabs .tabs-content');
const tabsPanel = $('.ranking--tabs__panel');
const rankingSliders = $('.js-ranking-slider');

if (rankingSliders.length) {

  const rankingSlider = new Swiper(rankingSliders, {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    init: false
  });

  if (rankingSliders.length > 1) {
    rankingSlider[0].init();
  } else {
    rankingSlider.init();
  }

  $(rankingTabs).on('change.zf.tabs', function (event, tab) {

    const tabId = tab.children('a').attr('data-tabs-target');

    tabsPanel.each(function() {
      if ($(this).attr('id') === tabId) {
        const tabIndex = tabId.split('-');
        const sliderIndex = tabIndex[1] - 1;

        if (!$('.swiper-container-initialized', this).length) {
          rankingSlider[sliderIndex].init();
        } else {
          rankingSlider[sliderIndex].update();
        }
      }
    });
  });

}

const tabsSlider = document.querySelectorAll('.js-tabs-slider');
const tabsSliderOverlay = $('.js-tabs-slider').siblings('.overlay');

if (tabsSlider.length) {

  
  // For each Carousel
  const carousels = tabsSlider;
  carousels.forEach((el , i) => {
    
    
    // Carousel have more than one slide
    if (el.querySelectorAll('.swiper-slide').length > 1) {

      // At Load
      const swiperDims = el.getBoundingClientRect();
      let slidesDims = 0
      el.querySelectorAll('.swiper-slide').forEach((el) => {
        slidesDims = slidesDims + el.getBoundingClientRect().width
      });

      const initialSlide = parseInt(el.querySelector('.swiper-slide.is-active').getAttribute('data-number'), 10);

      const freeSwiper = new Swiper(el, {
        speed: 400,
        grabCursor: true,
        slidesPerView: 'auto',
        freeMode: true,
        centeredSlides: true,
        initialSlide: initialSlide,
        // resistanceRatio: 0,
        on: {
          touchMove: function () {
            tabsSliderOverlay.fadeIn(100);
          },
          reachEnd: function () {
            tabsSliderOverlay.fadeOut(200);
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        init: false
      });

      // 1st Init au chargement de la page
      if (slidesDims > swiperDims.width) {
        freeSwiper.init();
      }

      // On orientation change
      $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
        freeSwiper.init();
        freeSwiper.update();
      });

    }
  })
}

